import React from 'react';
import ReactDOM from 'react-dom/client';
import Configurator from './configurator-app';
import Search from './instant-search-app';
import FullPageSearch from './full-page-search-app';
import MMMWidget from './mmm_widget-app';
import MakeMachineModel from './make-machine-model-app';


async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return
  }
  console.info('Enabling mocking');
 
  const { worker } = await import('./mocks/browser-setup')
 
  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start()
}

const configuratorRootElement = document.getElementById('configurator-root');
if (configuratorRootElement) {
  const root = ReactDOM.createRoot(configuratorRootElement);
  enableMocking().then(() => {
    root.render(
      <React.StrictMode>
        <Configurator />
      </React.StrictMode>
    );
  })
}

const instantSearchRootElement = document.getElementById('instantsearch_root');
if (instantSearchRootElement) {
  const root = ReactDOM.createRoot(instantSearchRootElement);
  root.render(
    <React.StrictMode>
      <Search />
    </React.StrictMode>
  );
}

const fullPageSearchRootElement = document.getElementById('full_page_search_root');
if (fullPageSearchRootElement) {
  const root = ReactDOM.createRoot(fullPageSearchRootElement);
  // enableMocking().then(() => {
    root.render(
      <React.StrictMode>
        <FullPageSearch />
      </React.StrictMode>
    );
  // })
}


const mmmWidgetRootElement = document.getElementById('mmm_widget_root');
if (mmmWidgetRootElement) {
  const root = ReactDOM.createRoot(mmmWidgetRootElement);
  enableMocking().then(() => {
    root.render(
      <React.StrictMode>
         <MMMWidget/>
      </React.StrictMode>
    );
  })
}
const makeMachineModelRootElement = document.getElementById('make-machine-model-root');
  const root = ReactDOM.createRoot(makeMachineModelRootElement);
  enableMocking().then(() => {
    root.render(
      <React.StrictMode>
        <MakeMachineModel />
      </React.StrictMode>
    );
  })
